var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterVectorLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8177 18.0217C13.1985 24.602 10.2849 37.1939 15.228 46.3862L5.17563 54.0607C-3.06222 39.1002 1.61311 18.3628 15.8109 7.52356C30.0086 -3.31568 48.3488 -0.149379 57.0245 14.4768L46.9798 22.1454C41.6025 13.2845 30.4369 11.4414 21.8177 18.0217Z",
    stroke: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterVectorLeft);
export default __webpack_public_path__ + "static/media/master-vector-left.5839032c975ced5c0f267d3389a4320c.svg";
export { ForwardRef as ReactComponent };